import {Component, Input} from '@angular/core';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';

@Component({
  selector: 'app-indication-item',
  templateUrl: './indication-item.component.html',
  styleUrls: ['./indication-item.component.scss']
})
export class IndicationItemComponent {

  @Input() indication?: IndicationBasicModel;
}
